import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import createHistory from 'history/createMemoryHistory';
import Routes from './routes';

export const history = createHistory();

const Router = () => (
  <ConnectedRouter history={history}>
    <Routes history={history} />
  </ConnectedRouter>
);

export default Router;
